export default __webpack_public_path__ + "static/media/pyramid-example.b59ce1bc.png";